"use strict";(()=>{var G=Object.defineProperty,N=Object.defineProperties;var J=Object.getOwnPropertyDescriptors;var w=Object.getOwnPropertySymbols;var q=Object.prototype.hasOwnProperty,K=Object.prototype.propertyIsEnumerable;var k=(o,t,r)=>t in o?G(o,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):o[t]=r,p=(o,t)=>{for(var r in t||(t={}))q.call(t,r)&&k(o,r,t[r]);if(w)for(var r of w(t))K.call(t,r)&&k(o,r,t[r]);return o},$=(o,t)=>N(o,J(t));var S;(function(o){o.FIRST_PARTY="firstParty",o.THIRD_PARTY="thirdParty"})(S||(S={}));var g=Object.freeze({markWidgetLoaded:o=>{typeof window!="undefined"&&window.performance&&window.performance.mark&&window.performance.mark(`yotpo:${o}:loaded`)},markWidgetStart:(o,t)=>{typeof window!="undefined"&&window.performance&&window.performance.mark&&window.performance.mark(`yotpo:${o}:start`,{detail:t})},markWidgetEnd:(o,t)=>{typeof window!="undefined"&&window.performance&&window.performance.mark&&window.performance.mark(`yotpo:${o}:end`,{detail:t})}});var V=()=>{var o,t;return!(typeof window.Yotpo=="undefined"||!(!((o=window==null?void 0:window.yotpoWidgetsContainer)===null||o===void 0)&&o.Analytics)||!(!((t=window==null?void 0:window.yotpoWidgetsContainer)===null||t===void 0)&&t.AnalyticsTools))},y={},X=o=>{let{guid:t,category:r}=o;return`${t}_${r}`},C=o=>{let t=X(o);return y[t]||(y[t]=new f(o)),y[t]},f=class{constructor(t){this.getYotpoAnalytics(t)}async trackCustomWidgetAction(t,r,i,a){return this.trackWidgetEvent(t,r,i,a)}async trackClickedOn(t,r,i){return this.trackWidgetEvent("clicked_on",t,r,i)}async trackError(t,r,i){return this.trackWidgetEvent("error",t,r,i)}async trackFilterResults(t,r,i){return this.trackWidgetEvent("filter_results",t,r,i)}async trackHidden(t,r,i){return this.trackWidgetEvent("hidden",t,r,i)}async trackHook(t,r,i){return this.trackWidgetEvent("hook",t,r,i)}async trackHovered(t,r,i){return this.trackWidgetEvent("hovered",t,r,i)}async trackLoaded(t,r,i){return this.trackWidgetEvent("loaded",t,r,i)}async trackShown(t,r,i){return this.trackWidgetEvent("shown",t,r,i)}async trackWidgetLoaded(t,r,i){let a=await this.analyticsLoadingPromise;return a?a.trackWidgetLoaded(t,r,i):Promise.resolve(!1)}async getDomainUserId(){return this.analyticsLoadingPromise.then(t=>t?t==null?void 0:t.getDomainUserId():null)}async getHashFunction(){return this.analyticsLoadingPromise.then(t=>t?t==null?void 0:t.getHashFunction():()=>"")}createYotpoAnalyticsWithRetries(t,r,i){if(t<=0){r(!1);return}if(!V()){setTimeout(()=>{t-=1,this.createYotpoAnalyticsWithRetries(t,r,i)},50);return}r(!0)}getYotpoAnalytics(t){return this.analyticsLoadingPromise||(this.analyticsLoadingPromise=new Promise((r,i)=>{this.createYotpoAnalyticsWithRetries(10,r,i)}).then(r=>r?window.yotpoWidgetsContainer.AnalyticsTools.WidgetsAnalyticsFactory(t):null)),this.analyticsLoadingPromise}async trackWidgetEvent(t,r,i,a){let n=await this.analyticsLoadingPromise;return n?n==null?void 0:n.trackWidgetEvent(t,r,i,a):Promise.resolve(!1)}};var u=null;function T(o){return u=C(o),u}function E(){if(!u)throw new Error("Analytics not initialized. Call initAnalytics() first.");return u}var A="claim_pixel_id";function B(){try{let t=localStorage.getItem(A);if(t){let{id:r,ts:i}=JSON.parse(t);if(Date.now()-i<864e5)return r}}catch(t){}let o=crypto.randomUUID();try{localStorage.setItem(A,JSON.stringify({id:o,ts:Date.now()}))}catch(t){}return o}var x=null;function P(){return x||(x=crypto.randomUUID()),x}function L(){let o=navigator.userAgent;return/Mobi|Android/i.test(o)?"mobile":/iPad|Tablet/i.test(o)?"tablet":"desktop"}function D(){var o;return(o=window.__st)==null?void 0:o.cid}function W(){var o;return(o=window.__st)==null?void 0:o.em}var h=null;function I(o,t,r){h={page_url:window.location.href,device_type:L(),pixel_id:B(),session_id:P(),customer_id:D(),customer_email:W(),campaign_id:r.campaignId,merchant_id:r.merchantId,merchant_guid:r.merchantGuid,channel:r.channel,widget_name:o,widget_uuid:t}}function z(){if(!h)throw new Error("Event context not initialized. Call initEventContext() first.");return $(p({},h),{page_url:window.location.href})}function Q(o,t,r,i){try{let a=i,n=p(p({},z()),a),c=o[t];if(typeof c=="function"){c(r,JSON.stringify(a),n);return}console.error(`[claim-events] analytics.${t} is not a function for "${r}"`)}catch(a){console.error(`[claim-events] failed to send "${r}"`,a)}}function b(o,t){Q(o,"trackClickedOn","claim_banner_clicked",t)}var e="cliganic-success-dialog";function Z(){let o=null;try{o=E()}catch(r){}let t=(r,i)=>{try{o&&typeof o[r]=="function"&&o[r](...i)}catch(a){console.warn(`[claim-success-dialog] analytics.${r} failed`,a)}};return{trackShown:(r,i)=>t("trackShown",[r,i]),trackHidden:(r,i)=>t("trackHidden",[r,i]),trackClickedOn:(r,i)=>t("trackClickedOn",[r,i]),trackCustomWidgetAction:(r,i,a,n)=>t("trackCustomWidgetAction",[r,i,a,n])}}function tt(o){try{let t=new URL(window.location.href);if(!t.searchParams.has(o))return;t.searchParams.delete(o);let r=t.searchParams.toString();window.history.replaceState({},"",`${t.pathname}${r?`?${r}`:""}${t.hash}`)}catch(t){}}function et(){let o=window.location.pathname;return o==="/"||o===""?"home":o.includes("/collections")?"collection":o.includes("/products")?"product":o.includes("/thank_you")||o.includes("/checkout")?"post-checkout":"other"}function rt(o){let{theme:t,fonts:r}=o;return`
    @import url('${r.googleFontsUrl}');

    .${e}-scrim {
      position: fixed;
      inset: 0;
      z-index: 2147483000;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: clamp(12px, 3vw, 32px);
      background: rgba(26, 43, 42, 0.45);
      backdrop-filter: blur(6px);
      -webkit-backdrop-filter: blur(6px);
      opacity: 0;
      transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      will-change: opacity;
    }

    .${e}-scrim--visible {
      opacity: 1;
    }

    .${e} *,
    .${e} *::before,
    .${e} *::after {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
    }

    .${e} {
      --color-primary: ${t.colorPrimary};
      --color-secondary: ${t.colorSecondary};
      --color-accent: ${t.colorAccent};
      --color-background: ${t.colorBackground};
      --color-surface: ${t.colorSurface};
      --color-text-primary: ${t.colorTextPrimary};
      --color-text-muted: ${t.colorTextMuted};
      --color-cta-bg: ${t.colorCtaBg};
      --color-cta-text: ${t.colorCtaText};
      --color-cta-hover: ${t.colorCtaHover};
      --color-badge-bg: ${t.colorBadgeBg};
      --color-badge-text: ${t.colorBadgeText};
      --color-panel-bg: ${t.colorPanelBg};
      --color-overlay-bg: ${t.colorOverlayBg};
      --color-overlay-text: ${t.colorOverlayText};
      --color-link: ${t.colorLink};
      --radius-card: ${t.cardBorderRadius};
      --radius-button: ${t.buttonBorderRadius};
      --radius-badge: ${t.badgeBorderRadius};
      --font-display: ${r.display};
      --font-body: ${r.body};

      position: relative;
      display: grid;
      grid-template-columns: 1fr 1fr;
      width: 100%;
      max-width: 980px;
      max-height: 92vh;
      background: var(--color-surface);
      border-radius: var(--radius-card);
      overflow: hidden;
      box-shadow:
        0 8px 32px rgba(0, 0, 0, 0.14),
        0 24px 64px rgba(0, 0, 0, 0.12);
      opacity: 0;
      transform: translateY(16px) scale(0.98);
      transition: opacity 0.45s cubic-bezier(0.4, 0, 0.2, 1),
                  transform 0.45s cubic-bezier(0.4, 0, 0.2, 1);
      will-change: opacity, transform;
    }

    .${e}--visible {
      opacity: 1;
      transform: translateY(0) scale(1);
    }

    /* Close button */
    .${e}__close {
      position: absolute;
      top: 16px;
      right: 16px;
      z-index: 5;
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(253, 251, 247, 0.9);
      border: 1px solid rgba(26, 43, 42, 0.12);
      border-radius: 50%;
      cursor: pointer;
      color: var(--color-text-muted);
      transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1),
                  background-color 0.2s, color 0.2s;
    }

    .${e}__close:hover {
      background: #fff;
      color: var(--color-text-primary);
      transform: scale(1.08) rotate(90deg);
    }

    .${e}__close svg {
      width: 18px;
      height: 18px;
    }

    /* Left column \u2014 product panel */
    .${e}__panel {
      position: relative;
      background: var(--color-panel-bg);
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      min-height: 480px;
    }

    .${e}__product-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .${e}__panel:hover .${e}__product-img {
      transform: scale(1.04);
    }

    /* Floating retailer badges */
    .${e}__retailer-badge {
      position: absolute;
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 14px;
      background: rgba(255, 255, 255, 0.95);
      backdrop-filter: blur(8px);
      -webkit-backdrop-filter: blur(8px);
      border-radius: 28px;
      box-shadow:
        0 2px 8px rgba(0, 0, 0, 0.08),
        0 4px 16px rgba(0, 0, 0, 0.05);
      animation: ${e}-floatIn 0.6s cubic-bezier(0.4, 0, 0.2, 1) backwards;
    }

    .${e}__retailer-badge:nth-child(1) {
      top: 18%;
      left: 8%;
      animation-delay: 0.35s;
    }

    .${e}__retailer-badge:nth-child(2) {
      top: 19%;
      right: 5%;
      left: auto;
      animation-delay: 0.5s;
    }

    .${e}__retailer-badge:nth-child(3) {
      bottom: 28%;
      right: 8%;
      left: auto;
      animation-delay: 0.65s;
    }

    .${e}__retailer-badge-points {
      font-family: var(--font-body);
      font-size: 16px;
      font-weight: 700;
      color: var(--color-primary);
    }

    .${e}__retailer-badge-info {
      display: flex;
      flex-direction: column;
      gap: 1px;
    }

    .${e}__retailer-badge-label {
      font-family: var(--font-body);
      font-size: 9px;
      font-weight: 500;
      color: var(--color-text-muted);
      text-transform: uppercase;
      letter-spacing: 0.04em;
    }

    .${e}__retailer-badge-name {
      font-family: var(--font-body);
      font-size: 13px;
      font-weight: 700;
      color: var(--color-text-primary);
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .${e}__retailer-badge-icon {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      object-fit: contain;
    }

    .${e}__retailer-badge-verified {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background: #22C55E;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .${e}__retailer-badge-verified svg {
      width: 10px;
      height: 10px;
      fill: white;
    }

    /* Points summary overlay */
    .${e}__points-summary {
      position: absolute;
      bottom: 6%;
      left: 50%;
      transform: translateX(-50%);
      padding: 16px 24px;
      background: var(--color-overlay-bg);
      border-radius: 12px;
      text-align: center;
      white-space: nowrap;
      box-shadow:
        0 4px 16px rgba(0, 0, 0, 0.15),
        0 8px 32px rgba(0, 0, 0, 0.1);
      animation: ${e}-floatInCenter 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.8s backwards;
    }

    .${e}__points-summary-text {
      font-family: var(--font-body);
      font-size: clamp(18px, 2vw, 22px);
      font-weight: 700;
      color: var(--color-overlay-text);
      letter-spacing: -0.01em;
    }

    .${e}__points-summary-sub {
      font-family: var(--font-body);
      font-size: clamp(11px, 1vw, 13px);
      font-weight: 400;
      color: rgba(255, 255, 255, 0.8);
      margin-top: 2px;
    }

    /* Right column \u2014 content */
    .${e}__content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: clamp(32px, 4vw, 52px);
      gap: clamp(14px, 2vw, 20px);
      overflow-y: auto;
    }

    .${e}__status {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .${e}__status-check {
      width: 44px;
      height: 44px;
      flex-shrink: 0;
      border-radius: 50%;
      background: var(--color-badge-bg);
      display: flex;
      align-items: center;
      justify-content: center;
      animation: ${e}-pop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.25s backwards;
    }

    .${e}__status-check svg {
      width: 22px;
      height: 22px;
      fill: none;
      stroke: var(--color-primary);
      stroke-width: 2.5;
      stroke-linecap: round;
      stroke-linejoin: round;
    }

    .${e}__status-label {
      font-family: var(--font-body);
      font-size: clamp(12px, 1.1vw, 14px);
      font-weight: 600;
      letter-spacing: 0.12em;
      color: var(--color-secondary);
      text-transform: uppercase;
    }

    .${e}__headline {
      font-family: var(--font-display);
      font-size: clamp(24px, 3.2vw, 38px);
      font-weight: 400;
      color: var(--color-primary);
      line-height: 1.2;
      letter-spacing: -0.01em;
      white-space: pre-line;
    }

    .${e}__body {
      font-family: var(--font-body);
      font-size: clamp(14px, 1.3vw, 16px);
      color: var(--color-text-primary);
      line-height: 1.6;
      max-width: 440px;
    }

    .${e}__body strong {
      font-weight: 700;
      color: var(--color-primary);
    }

    .${e}__scanning-pill {
      display: inline-flex;
      align-items: center;
      align-self: flex-start;
      gap: 10px;
      padding: 10px 18px;
      background: var(--color-badge-bg);
      color: var(--color-badge-text);
      font-family: var(--font-body);
      font-size: clamp(12px, 1.1vw, 14px);
      font-weight: 600;
      border-radius: var(--radius-badge);
    }

    .${e}__scanning-dot {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: var(--color-secondary);
      flex-shrink: 0;
      animation: ${e}-pulse 1.6s ease-in-out infinite;
    }

    .${e}__cta-primary {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-top: 8px;
      padding: clamp(16px, 1.6vw, 20px) clamp(24px, 3vw, 36px);
      background: var(--color-cta-bg);
      color: var(--color-cta-text);
      font-family: var(--font-body);
      font-size: clamp(13px, 1.1vw, 15px);
      font-weight: 700;
      letter-spacing: 0.06em;
      text-decoration: none;
      border: none;
      border-radius: var(--radius-button);
      cursor: pointer;
      transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1),
                  background-color 0.25s,
                  box-shadow 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: 0 2px 8px rgba(27, 75, 67, 0.2);
    }

    .${e}__cta-primary:hover {
      background: var(--color-cta-hover);
      transform: scale(1.02);
      box-shadow: 0 6px 20px rgba(27, 75, 67, 0.3);
    }

    .${e}__cta-secondary {
      display: block;
      text-align: center;
      font-family: var(--font-body);
      font-size: clamp(13px, 1.1vw, 15px);
      font-weight: 700;
      color: var(--color-link);
      text-decoration: none;
      transition: opacity 0.2s;
    }

    .${e}__cta-secondary:hover {
      opacity: 0.7;
    }

    .${e}__divider {
      height: 1px;
      background: rgba(26, 43, 42, 0.1);
      margin: 4px 0;
    }

    .${e}__powered-by {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      font-family: var(--font-body);
      font-size: 12px;
      color: var(--color-text-muted);
      text-decoration: none;
      transition: opacity 0.2s;
    }

    .${e}__powered-by:hover {
      opacity: 0.7;
    }

    .${e}__powered-by-logo {
      height: 18px;
      width: auto;
    }

    @keyframes ${e}-floatIn {
      from { opacity: 0; transform: translateY(12px); }
      to { opacity: 1; transform: translateY(0); }
    }

    @keyframes ${e}-floatInCenter {
      from { opacity: 0; transform: translateX(-50%) translateY(12px); }
      to { opacity: 1; transform: translateX(-50%) translateY(0); }
    }

    @keyframes ${e}-pop {
      from { opacity: 0; transform: scale(0.6); }
      to { opacity: 1; transform: scale(1); }
    }

    @keyframes ${e}-pulse {
      0%, 100% { opacity: 1; transform: scale(1); }
      50% { opacity: 0.4; transform: scale(0.8); }
    }

    @media (max-width: 768px) {
      .${e} {
        grid-template-columns: 1fr;
        max-height: 94vh;
        overflow-y: auto;
      }

      .${e}__panel {
        min-height: 240px;
        order: -1;
      }

      .${e}__content {
        padding: 28px 22px;
        gap: 14px;
      }

      .${e}__headline {
        font-size: 24px;
      }

      .${e}__points-summary {
        padding: 10px 18px;
      }

      .${e}__points-summary-text {
        font-size: 16px;
      }

      .${e}__retailer-badge {
        padding: 6px 10px;
      }

      .${e}__retailer-badge-points {
        font-size: 13px;
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .${e}-scrim,
      .${e},
      .${e} * {
        transition: none !important;
        animation: none !important;
      }
    }
  `}function ot(o){let{content:t,product:r}=o,i=t.retailerBadges.map(a=>{let n=a.icon?`<img class="${e}__retailer-badge-icon" src="${a.icon}" alt="${a.retailer}" />`:"",c=a.verified?`<span class="${e}__retailer-badge-verified"><svg viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg></span>`:"";return`
      <div class="${e}__retailer-badge">
        <span class="${e}__retailer-badge-points">${a.points}</span>
        <div class="${e}__retailer-badge-info">
          <span class="${e}__retailer-badge-label">POINTS EARNED</span>
          <span class="${e}__retailer-badge-name">${n}${a.retailer}${c}</span>
        </div>
      </div>
    `}).join("");return`
    <button class="${e}__close" aria-label="Close">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
    </button>
    <div class="${e}__panel">
      <img
        class="${e}__product-img"
        src="${r.imageUrl}"
        alt="${r.imageAlt}"
        loading="eager"
      />
      ${i}
      <div class="${e}__points-summary">
        <div class="${e}__points-summary-text">${t.pointsSummaryText}</div>
        <div class="${e}__points-summary-sub">${t.pointsSummarySubtext}</div>
      </div>
    </div>
    <div class="${e}__content">
      <div class="${e}__status">
        <span class="${e}__status-check">
          <svg viewBox="0 0 24 24"><polyline points="4 12 10 18 20 6"/></svg>
        </span>
        <span class="${e}__status-label">${t.statusLabel}</span>
      </div>
      <h2 class="${e}__headline">${t.headline}</h2>
      <p class="${e}__body">${t.body}</p>
      <div class="${e}__scanning-pill">
        <span class="${e}__scanning-dot"></span>
        ${t.scanningPillText}
      </div>
      <button type="button" class="${e}__cta-primary">${t.ctaPrimaryText}</button>
      <a
        class="${e}__cta-secondary"
        href="${t.ctaSecondaryHref}"
      >${t.ctaSecondaryText}</a>
      <div class="${e}__divider"></div>
      <a class="${e}__powered-by" href="https://www.loyaltyclaim.com/" target="_blank" rel="noopener">
        ${t.poweredByText}
        <img class="${e}__powered-by-logo" src="${t.poweredByLogoSrc}" alt="Claim" />
      </a>
    </div>
  `}function F(o){if(new URLSearchParams(window.location.search).get(o.trigger.param)!==o.trigger.value)return;let r=Z(),i=et(),a=o.content.headline.replace(/\n/g," "),n=document.createElement("style");n.textContent=rt(o),document.head.appendChild(n);let c=document.createElement("div");c.className=`${e}-scrim`;let s=document.createElement("div");s.className=e,s.setAttribute("role","dialog"),s.setAttribute("aria-modal","true"),s.innerHTML=ot(o),c.appendChild(s),document.body.appendChild(c);let U=document.body.style.overflow,v=!1,m=d=>{v||(v=!0,c.classList.remove(`${e}-scrim--visible`),s.classList.remove(`${e}--visible`),r.trackHidden("claim-success-dialog",d),document.removeEventListener("keydown",_),document.body.style.overflow=U,setTimeout(()=>c.remove(),450))},_=d=>{d.key==="Escape"&&m("esc_key")},H=()=>{c.classList.add(`${e}-scrim--visible`),requestAnimationFrame(()=>s.classList.add(`${e}--visible`)),document.body.style.overflow="hidden",document.addEventListener("keydown",_),r.trackShown("claim_consent_submitted",void 0)},M=s.querySelector(`.${e}__close`),j=s.querySelector(`.${e}__cta-primary`),Y=s.querySelector(`.${e}__cta-secondary`);M.addEventListener("click",()=>m("close_button")),c.addEventListener("click",d=>{d.target===c&&m("backdrop")}),j.addEventListener("click",()=>{r.trackClickedOn("claim-success-dialog","primary"),b(r,{banner_text:a,banner_location:i}),tt(o.trigger.param),m("primary_cta")}),Y.addEventListener("click",()=>{r.trackClickedOn("claim-success-dialog","secondary"),b(r,{banner_text:a,banner_location:i})}),H()}var l={trigger:{type:"url-param",param:"claim_connection_status",value:"success"},content:{statusLabel:"CONNECTED",headline:`You\u2019re in,
100 points added.`,body:"That welcome bonus just landed. We\u2019re now scanning your receipts to credit everything you\u2019ve already bought \u2014 and you\u2019ll earn on <strong>every purchase from here.</strong>",scanningPillText:"Scanning Amazon, iHerb and Target receipts",ctaPrimaryText:"CONTINUE SHOPPING",ctaSecondaryText:"View my rewards page",ctaSecondaryHref:"https://www.cliganic.com/pages/rewards",poweredByText:"Powered by",poweredByLogoSrc:"https://www.loyaltyclaim.com/_next/image?url=%2Fclaim-logo.png&w=384&q=75",retailerBadges:[{points:"+450",retailer:"amazon",icon:"https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg",verified:!1},{points:"+200",retailer:"iHerb",icon:"",verified:!0},{points:"+150",retailer:"Target",icon:"https://upload.wikimedia.org/wikipedia/commons/9/9a/Target_logo.svg",verified:!1}],pointsSummaryText:"+3,200 points confirmed",pointsSummarySubtext:"All your purchases. One rewards balance."},theme:{colorPrimary:"#1B4B43",colorSecondary:"#2C6B5A",colorAccent:"#B8D4C8",colorBackground:"#F5F0E8",colorSurface:"#FDFBF7",colorTextPrimary:"#1A2B2A",colorTextMuted:"#5A6B68",colorCtaBg:"#1B4B43",colorCtaText:"#FFFFFF",colorCtaHover:"#153A34",colorBadgeBg:"#D4EDE2",colorBadgeText:"#1B4B43",colorPanelBg:"#EDE7DC",colorOverlayBg:"#1B4B43",colorOverlayText:"#FFFFFF",colorLink:"#1B4B43",cardBorderRadius:"16px",buttonBorderRadius:"8px",badgeBorderRadius:"20px"},fonts:{display:"Libre Baskerville, serif",body:"DM Sans, sans-serif",mono:"JetBrains Mono, monospace",googleFontsUrl:"https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Libre+Baskerville:wght@400;700&display=swap"},product:{name:"Organic Argan Oil",imageUrl:"https://cdn.shopify.com/s/files/1/1565/1267/files/organic-argan-oilskin-hair-oils-5412934.jpg?v=1760407924",imageAlt:"Cliganic Organic Argan Oil bottle"},analytics:{campaignId:"claim-success-dialog-default",merchantId:"WBSbUotgi5amop9LJtYKsSaz6UGWOFEc7pWzM0x5",channel:"site",formId:"oauth-consent-rewards-hero"}};var it=new URLSearchParams(window.location.search),at=it.get(l.trigger.param)===l.trigger.value,O,R;if(at){let o=(R=(O=window.swellConfig)==null?void 0:O.merchantGuid)!=null?R:"WBSbUotgi5amop9LJtYKsSaz6UGWOFEc7pWzM0x5";try{let t=typeof crypto!="undefined"&&"randomUUID"in crypto?crypto.randomUUID():`${Date.now()}-${Math.random().toString(16).slice(2)}`;g.markWidgetStart("claim-success-dialog",t),T({guid:o,category:"claim",widgetUuid:t,preventEvents:!1,defaultContext:{is_mobile:/Mobi|Android/i.test(navigator.userAgent)}}),I("claim-success-dialog",t,{campaignId:l.analytics.campaignId,merchantId:l.analytics.merchantId,merchantGuid:o,channel:l.analytics.channel}),g.markWidgetEnd("claim-success-dialog",t),g.markWidgetLoaded("claim-success-dialog")}catch(t){console.warn("[claim-success-dialog] analytics init failed, showing dialog anyway",t)}F(l)}})();
